import { Box, Typography } from '@mui/material'

import * as COLORS from '@/app/theme/colors/flyin'

interface BarDataItem {
    shortLabel: string
    value: number
    heightPercent: number
}

interface BarChartProps {
    data: BarDataItem[]
    title: string
    unit: string
}

const BarChart: React.FC<BarChartProps> = ({ data, title, unit }) => {
    return (
        <Box
            sx={{
                mb: 3,
                border: 1,
                borderColor: 'grey.200',
                borderRadius: 2,
                p: 2
            }}
        >
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
                {title}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.5, height: 140, minWidth: 0, overflow: 'hidden' }}>
                {data.map((item, index) => (
                    <Box key={index} sx={{ flex: 1, textAlign: 'center', minWidth: 0 }}>
                        <Typography variant="caption" sx={{ fontSize: '0.6rem', display: 'block', mb: 0.5, color: 'text.secondary' }}>
                            {Math.round(item.value)}
                        </Typography>
                        <Box
                            sx={{
                                height: `${item.heightPercent}%`,
                                minHeight: 4,
                                bgcolor: COLORS.CHART_BAR_FARE,
                                borderRadius: '3px 3px 0 0',
                                mx: 'auto',
                                width: '100%',
                                maxWidth: 36
                            }}
                        />
                        <Typography
                            variant="caption"
                            sx={{
                                fontSize: '0.6rem',
                                display: 'block',
                                mt: 0.5,
                                color: 'text.secondary',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                        >
                            {item.shortLabel}
                        </Typography>
                    </Box>
                ))}
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                {unit}
            </Typography>
        </Box>
    )
}

export default BarChart
export type { BarChartProps, BarDataItem }
